import _ from 'lodash';
import {
  FormPage,
  FormPageField,
  FormPageSource,
  FormPageFieldInfo,
  FormPageRecord,
  FormPageConfigDetails,
} from 'types/formPage';
import { FormPageRecordMode } from 'data';

const FormPageFilterKeys = {
  primarySource: (formPage: FormPage) => _.find(_.get(formPage, 'details.sources', []), { primary: true }),
  sources: (formPage: FormPage): FormPageSource[] => _.get(formPage, 'details.sources', []),
  fields: (formPage: FormPage): FormPageField[] => _.get(formPage, 'details.fields', []),
  header: (formPage: FormPage): FormPageFieldInfo => _.get(formPage, 'details.header'),
  subHeader: (formPage: FormPage): FormPageFieldInfo => _.get(formPage, 'details.sub_header'),
  submitBtn: (formPage: FormPage): FormPageFieldInfo => _.get(formPage, 'details.submit_btn'),
  webhook: (formPage: FormPage): string => _.get(formPage, 'details.webhook'),
  record: (formPage: FormPage): FormPageRecord => _.get(formPage, 'details.record'),
  recordMode: (formPage: FormPage): FormPageRecordMode => _.get(formPage, 'details.record.mode'),
  recordId: (formPage: FormPage): string => _.get(formPage, 'details.record.id'),
  details: (formPage: FormPage): FormPageConfigDetails => _.get(formPage, 'details', {}),
};
export const filterFormPage = (
  formPage: FormPage,
  ...keys: Array<keyof typeof FormPageFilterKeys>
): { [key in keyof typeof FormPageFilterKeys]: any } | any => {
  if (keys.length === 1) {
    return FormPageFilterKeys[keys[0]](formPage);
  }
  return keys.reduce((acc, key) => {
    acc[key] = FormPageFilterKeys[key](formPage);
    return acc;
  }, {} as any);
};
export const storeFormFields = (store, formId ) => _.get(store.formPage.data,`${currFormId(formId)}.details.fields`) || []

export const storeFormField = (store, formId, fieldMatch ) => {
  const fields = storeFormFields(store,formId)
  const field = fields.find( f => [f.title,f.name,f.id].includes( fieldMatch) )
  return field
}

export const storeFormData = (store, formId ) => _.get(store,`formData.data.${formId}.data`) || {}


export const currFormId = paths => Array.isArray(paths) ? _.last(paths) : paths